import { useEffect } from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  useLocation,
} from "react-router-dom";
import "./App.css";

// Navigation
import Header from "./components/Header";
import Footer from "./components/Footer";
import Studios from "./components/Studios.js";
import Work from "./pages/Work";
import About from "./pages/About.js";
import Contact from "./pages/Contact";
import Creators from "./components/Creators.js";
import Creator from "./pages/Creator.js";

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  return (
    <Router>
      <div>
        <ScrollToTop />
        <Header />
        <main className="min-h-screen">
          <Switch>
            <Route exact path="/">
              <Work />
            </Route>
            <Route path="/writers">
              <Creators />
            </Route>
            <Route path="/about">
              <About />
            </Route>
            <Route path="/contact">
              <Contact />
            </Route>
            <Route path="/releases">
              <Work />
            </Route>
            <Route path="/studios">
              <Studios />
            </Route>
            <Route path="/:creatorUrl" component={Creator} />
          </Switch>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
